import React from 'react';
import { Typography } from 'antd';
import JsonViewer from '../Common/JsonViewer';

const { Paragraph, Text, Title } = Typography;

/** Long-form explanation, shown in the form's help drawer. */
const WebhookHelp = () => (
    <Typography>
        <Paragraph>
            A webhook fires automatically whenever a consumer submission produces change instances for the
            service it is attached to. You can also trigger one by hand from the webhooks list.
        </Paragraph>

        <Title level={5}>The request</Title>
        <Paragraph>
            NetOrca sends a POST to your target URL. The body carries the id NetOrca assigned to the service:
        </Paragraph>
        <JsonViewer
            data={{ service: 1 }}
            fontSize="13px"
            lineHeight="1.6"
        />
        <Paragraph style={{ marginTop: 12 }}>
            Authentication goes in the <Text code>Authorization</Text> header, for example{' '}
            <Text code>Api-Key &lt;key&gt;</Text>, <Text code>Token &lt;token&gt;</Text> or{' '}
            <Text code>Bearer &lt;jwt&gt;</Text>.
        </Paragraph>

        <Title level={5}>Batching</Title>
        <Paragraph>
            <Text strong>Wait time</Text> buffers events: several submissions landing together — merging a
            batch of MRs, approving many change instances at once — produce a single call rather than one per
            event. <Text strong>Cool-down</Text> blocks a follow-up call for a while after one has been sent.
        </Paragraph>

        <Title level={5}>Responses</Title>
        <Paragraph>
            Every call is recorded with its status code and response body under the Responses tab on the
            webhooks list. Only the last few responses per webhook are kept, and manual triggers are limited
            to three per minute.
        </Paragraph>
    </Typography>
);

export default WebhookHelp;
